<template>
    <div class="course-progress">
        <svg
            class="total"
            width="50"
            height="50"
        >
            <circle
                r="22.5"
                cx="25"
                cy="25"
                stroke-width="5"
                fill="transparent"
                stroke-dasharray="141.37"
                stroke-dashoffset="0"></circle>
        </svg>
        <svg
            class="current"
            width="50"
            height="50">
            <circle
                r="22.5"
                cx="25"
                cy="25"
                stroke-width="5"
                fill="transparent"
                stroke-dasharray="141.37"
                :stroke-dashoffset="141.37 - ((2 * 3.14 * 22.5) * (progress / 100))"
                transform="rotate(-90)"
                transform-origin="center"></circle>
        </svg>
        <!-- <pre>{{course}}</pre> -->
        <strong>{{ progress }}%</strong>
    </div>
</template>

<script>
    export default {
        name: 'CourseProgress',
        props: {
            progress: {
                type: Number,
                default: null
            }
        }
    }
</script>

<style lang="scss" scoped>
.course-progress {
    display: inline-flex;
    position: relative;
    order: 3;

    svg {
        &.current {
            position: absolute;
            top: 0;
            left: 0;

            circle {
                stroke: var(--primary);
            }
        }

        &.total {
            circle {
                stroke: var(--primary-50);
            }
        }
    }

    strong {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.75rem;
    }
}
</style>
